import { useContext, useState } from 'react';
import { Context } from '../../DataStore';

import Loading from '../common/Loading';

import * as strings from '../../data/strings';
import * as constants from '../exports/constants';

import '../../styles/common/Assessment.scss';

const Assessment = (props) => {
    const { store, dispatch } = useContext(Context);
    const [assessmentLoading, setAssessmentLoading] = useState(false);

    const triggerAssessment = async (aid) => {
        setAssessmentLoading(true);

        const openAssessment = (data) => {
            setAssessmentLoading(false);

            const statusCopy = {
                ...store.status,
                modal: {
                    active: true,
                    action: 'viewAssessment',
                    data: {
                        title: strings.default[store.language].AssetsView.AssessmentText,
                        description: '',
                        value: data
                    }
                }
            };

            dispatch({
                type: 'status',
                data: statusCopy
            });
        }

        try {
            let data = {
                sid: store.status.space.sid,
                aid: aid,
                uuid: store.profile.uuid,
                sessionId: store.session.sessionId
            }
            const url = `${constants.services.url.api}/v2/intelligence/thread/quality/`;
            const response = await fetch(url, constants.services.config(data));
            const responseData = await response.json();

            const checkThreadAvailability = async (aid, store, dispatch, setAssessmentLoading, responseData, strings, constants) => {
                if (responseData.status === 'Success' && responseData.state === 'Processing') {
                    try {
                        // Wait for 5 seconds before checking again
                        await new Promise(resolve => setTimeout(resolve, 5000));

                        let data = {
                            aid: aid,
                            uuid: store.profile.uuid,
                            sessionId: store.session.sessionId
                        };

                        if (constants.services.devMode) console.log('Checking if assessment is available')

                        const url = `${constants.services.url.api}/v2/intelligence/thread/available/`;
                        const response = await fetch(url, constants.services.config(data));
                        const assessmentResponseData = await response.json();

                        if (constants.services.devMode) console.log(assessmentResponseData.state)

                        if (assessmentResponseData.status === 'Success' && assessmentResponseData.state === 'Ready') {
                            // Status is ready, show the modal
                            openAssessment(assessmentResponseData);
                        } else {
                            // Not ready yet, recursively call the function again
                            await checkThreadAvailability(aid, store, dispatch, setAssessmentLoading, responseData, strings, constants);
                        }
                    } catch (error) {
                        console.error("Error checking thread availability:", error);
                        setAssessmentLoading(false);
                    }
                } else {
                    setAssessmentLoading(false);
                }
            }

            // Recursive check if assessment is ready
            if (responseData.status === 'Success') {
                if (responseData.state === 'Processing') {
                    checkThreadAvailability(aid, store, dispatch, setAssessmentLoading, responseData, strings, constants);
                } else {
                    openAssessment(responseData);
                }
            } else {
                setAssessmentLoading(false);
            }
        } catch {
            setAssessmentLoading(false);
        }
    }

    return (
        <div className="Assessment">
            <button
                className="assessmentButton"
                disabled={assessmentLoading}
                onClick={() => triggerAssessment(props.response.aid)}>
                <div className={`assessmentBackground${assessmentLoading ? ' loading' : ''}`} />
                <div className="assessmentText">
                    {strings.default[store.language].AssetsView[assessmentLoading ? 'GeneratingAssessment' : 'AssessmentText']}
                </div>
                {assessmentLoading &&
                    <Loading active="true" />
                }
            </button>
        </div>
    );
}

export default Assessment;
